import React from "react"
import { useRecoilValue } from "recoil"
import { Text, Flex, Tab, VStack, Container, Box } from "@chakra-ui/react"
import { userListUpHandSelector } from "../../../recoil/atoms/users"
import { Icon } from "../../common/icons"
import { IoMdHand } from "react-icons/io"
import { useLocalUserType } from "../../../hooks/useLocalUserType"

const UserListIcon = ({ index, tabButtonStyle, el, handleOnClick }) => {
  const isUpHand = useRecoilValue(userListUpHandSelector)
  const { isModerator } = useLocalUserType()
  return (
    <Tab key={index} {...tabButtonStyle} bg="transparent" onClick={handleOnClick}>
      <VStack margin="4px 0px">
        <Container
          p="0"
          centerContent
          pos="relative"
        >
          <Flex pos="relative">
            {el.icon}
            {isUpHand && isModerator && (
              <Box position="absolute" top="-8px" right="-7px">
                <Icon src={IoMdHand} boxSize="0.7rem" color="#FFD700" />
              </Box>
            )}
          </Flex>
        </Container>
        <Container
          p="0"
          centerContent
          marginTop="0.2rem !important"
          marginBottom="0.1rem !important"
        >
          <Text
            fontSize={el.text.length > 9 ? "11px" : "13px"}
            display="inline"
            lineHeight={1}
            fontWeight="medium"
          >
            {el.text}
          </Text>
        </Container>
      </VStack>
    </Tab>
  )
}

export default UserListIcon
